import React from 'react';
import type { LscVodCandidate } from '../types';
import { getVodReviewNextAction } from '../vodTruth';

interface VodReviewNextActionProps {
  candidate: LscVodCandidate;
  suggestions?: Array<{ id?: string }>;
  className?: string;
}

const SEVERITY_STYLES: Record<
  'info' | 'success' | 'warning' | 'danger',
  string
> = {
  info: 'border-primary-700/60 bg-primary-900/20 text-primary-100',
  success: 'border-green-700/60 bg-green-900/20 text-green-100',
  warning: 'border-amber-700/60 bg-amber-900/20 text-amber-100',
  danger: 'border-red-800/60 bg-red-900/20 text-red-100',
};

const VodReviewNextAction: React.FC<VodReviewNextActionProps> = ({
  candidate,
  suggestions = [],
  className = '',
}) => {
  const action = getVodReviewNextAction(candidate, suggestions);
  if (!action) {
    return null;
  }

  const severityClass = SEVERITY_STYLES[action.severity];

  return (
    <section
      className={`rounded-lg border p-4 ${severityClass} ${className}`.trim()}
      data-testid="vod-review-next-action"
      data-next-action-key={action.key}
      data-next-action-severity={action.severity}
    >
      <h2 className="text-lg font-semibold mb-2" data-testid="vod-review-next-action-title">
        {action.title}
      </h2>
      <p className="text-sm opacity-90 mb-3" data-testid="vod-review-next-action-description">
        {action.description}
      </p>
      {action.primaryLabel && action.targetAnchor && (
        <a
          href={action.targetAnchor}
          className="inline-flex items-center text-sm font-medium underline underline-offset-2 hover:opacity-90 transition-opacity"
          data-testid="vod-review-next-action-link"
        >
          {action.primaryLabel}
        </a>
      )}
    </section>
  );
};

export default VodReviewNextAction;
